<template>
<div class="order-wrapper" id="print">
    <portal target-el="#filter">
          <TopHeader
          :paidto="paidto"
          v-on:printInvoice="printInvoice"/>
        </portal>

 <div class="pdfheader webnone" v-if="$store.invoice">
  <div class="row no-margin">
<div class="col invoiceleft">
{{client.name}}
</div>
<div class="col invoiceright">
<div class="">Invoice No:</div>
<div class="">{{$store.invoice.invoice_number}}</div>
</div>
</div>
</div>

 <div class="table-title row no-margin table-title-content">

  <div class="col-lg-3 col-md-3 content-section-left no-padding">

   <div class="content-section">
    <div class="content-list">
      <span class="content-list-title bold primary-text">
            {{transporter.name}}
          </span>
        </div>
    <div class="content-list">
       <span class="content-list-title">
            {{transporter.address}} <br/>
            {{transporter.city}}
              {{transporter.state}} - {{transporter.pincode}}
           </span>
         </div>
    <div class="content-list">
      <span class="content-list-title bold">
        GST IN :
       </span>
       <span class="content-list-title">
         {{gstinNumber}}
        </span>
      </div>
   </div>
  </div>
  <div class="col-lg-5 col-md-5 content-section-left">
   <div class="content-section">
    <div class="content-list">
      <span class="content-list-title bold primary-text">
        {{client.name}}
      </span>
    </div>
    <div class="content-list">
      <span class="content-list-title">
            {{depot.address}} <br/>
            {{depot.city}} <br/>
            {{depot.state}} - {{depot.pincode}}
          </span>
        </div>
    <div class="content-list">
      <span class="content-list-title bold">
        GST IN :
      </span>
      <span class="content-list-title">
        {{depot.gstn_no}}
      </span>
    </div>
   <!--  <div class="content-list">
      <span class="content-list-title bold">
        PAN :
      </span>
      <span class="content-list-title">
        PAN330917005320N
      </span>
    </div> -->
   </div>
  </div>
  <div class="col-lg-4 col-md-6 content-section-right no-padding">
   <div class="content-section">
    <div class="content-list">
      <span class="content-list-title">
        {{date | moment("DD MMM YYYY") }}
      </span>
    </div>
    <div class="content-list">
       <span class="content-list-title bold">
         Tax payable on reverese charge :
       </span>
       <span class="content-list-title">
         {{reversecharge}}
       </span>
     </div>
    <div class="content-list">
      <span class="content-list-title bold">
        Service Description :
      </span>
      <span class="content-list-title">
        Movement of goods by Road
      </span>
    </div>
    <div class="content-list">
      <span class="content-list-title bold">
        HSN/SAC :
      </span>
      <span class="content-list-title"> -- </span>
     </div>
    <!-- <div class="content-list">
     <div class="action">
      <Popover popper-class="popover-medium" placement="bottom-end" v-model="comment">
       <div class="popover-primary">
        <div class="popover-primary-header">
         <h3>COMMENTS</h3>
         <span class="remove-icon" @click="comment=false">
           <svgicon name="cancel" width="10" height="10" :original="true" />
          </span>
          </div>
          <div class="popover-primary-body">
            <Comments />
        </div>
       </div>
       <div slot="reference">
        <svgicon name="Comments" width="12"
        height="12" :original="true" />
        COMMENTS
      </div>
      </Popover>
     </div>
    </div> -->
   </div>
  </div>
 </div>
 <div class="summary-content">
  <div class="table-title">
   <h2>SUMMARY | {{payments.length}} INDENTS</h2>
 </div>
  <div class="order-list-wrapper">
  <div class="new">
  <div class="table">
   <Header />
   <div class="tablerow-scroll" style="max-height:300px;">
     <Row v-for="payment in payments" :payment="payment" :key="payment.id"/>
   </div>
 </div>
</div>
  <Footer :gstinList="transporter.gst_number" 
          :depot="depot" 
          v-if="payments.length" 
          v-on:paidtochanged="paidtochanged"
          v-on:gstinNumberUpdate="gstinNumberUpdate"/>
 </div>
 </div>


</div>
</template>

<script>
// import Breadcrumb from '../../invoices/summary/Breadcrumb';
import TopHeader from './topHeader';

import Header from './Header';
import Row from './Row';
import Footer from './Footer';
// import Comments from '../../invoices/summary/action/Comments';
import cssStyle  from '@common/styles-transporter/_print';

export default {
  components: {
    Header,
    Row,
    Footer,
    TopHeader,
    // Breadcrumb,
    // Comments,
  },
  data() {
    const payment = this.$store.payments;
    return {
      comment: false,
      paidto: payment.paid_to,
      reversecharge: `${payment.paid_to}` === '1' ? 'No' : 'Yes',
      gstinNumber:'',
    };
  },
  computed: {
    client() {
      return this.$store.state.app.data.clients[0];
    },
    depot() {
      return this.$store.payments.selected[0].depot;
    },
    transporter() {
      return this.$store.state.app.data.transporter;
    },
    date() {
      return this.$store.showInvoice ? this.$store.invoice.created_at :
        (new Date()).toISOString();
    },
    payments() {
      return this.$store.payments.selected;
    },
    checkReverse() {
      return this.$store.payments.paid_to;
    }
  },
  methods: {
    gstinNumberUpdate(data) {
      this.gstinNumber = data;
    },
    printInvoice () {
      const prtHtml = document.getElementById('print').innerHTML;
        const WinPrint = window.open('', '', 'top=0,left=0,height=100%,width=auto');
        WinPrint.document.write(`<!DOCTYPE html>
        <html>
        <head>
        <style media="screen">
        body{
          visibility: hidden
        }
        </style>
        <style type="text/css" media="print">
        ${cssStyle}
        </style>
        </head>
        <body>
        ${prtHtml}
        </body>
        </html>`);
        WinPrint.print();
        WinPrint.close();
        WinPrint.document.close();
    },
    paidtochanged(paidto) {
      this.paidto = paidto;
      this.reversecharge = paidto === '1' ? 'No' : 'Yes';
    },
  },
};
</script>
<style lang='scss'>
$fontSemibold: 'OpenSans-Semibold';
$fontBold: 'OpenSans-Bold';

.payment-actions {
    width: calc(100% - 1230px);
    text-align: right;
}
.order-content {
    padding-bottom: 30px;
    background: #fff;
    padding: 20px;
    box-shadow: 0 2px 4px 0 #ECECEC;
    height: 100vh;
    .table-row {
        padding-left: 15px;
    }
}
.table-title {
    &-content {
        background: #F9FAFA;
        padding: 0;
        border: 1px solid #EFEFEF;
    }
    .float-right {
        text-align: right;
    }
    h2 {
        font-family:$fontSemibold;
        font-size: 1.6rem;
        letter-spacing: 1.33px;
        padding: 0 0 15px;
        margin: 0;
        color: #234357;
    }
}
.content-section {
    &-left {
        float: left;
        display: inline-block;
        border-left: 0.5px solid #CECECE;
        padding: 0 16px;
        margin: 10px 0;
        &:first-child {
            border-left: 0.5px solid transparent;
        }
    }
    &-right {
        float: right;
        display: inline-block;
        text-align: right;
        background: #fff;
        padding: 10px 15px;
    }
}
.content-list {
    line-height: 22px;
    .primary-text {
        font-size: 1.4rem;
    }
    .bold {
        font-family:$fontSemibold;
    }
    &-title {
        font-size: 1.2rem;
        color: #404040;
    }
    .action {
        cursor: pointer;
        color: #376F99;
        font-family:$fontSemibold;
        font-size: 1.2rem;
    }
}
.invoice-right-action {
    width: calc(100% - 550px);
    text-align: right;
    padding-right: 25px !important;
}
.popover-primary {
    textarea {
        border: 1px solid #DEE5E6;
        width: 100%;
        border-radius: 2px;
        padding: 10px;
        margin: 20px 0;
        outline: none;
    }
}
.right-btn {
    float: right;
}
</style>
